<template>
  <div>
    <BaseLabelledInfo
      :label="$t('Company')"
      class="base-border-b pb-m"
    >
      {{ attributes.name }}
    </BaseLabelledInfo>
    <BaseLabelledInfo
      :label="$t('Website')"
      class="base-border-b pb-m"
    >
      <a :href="`http://${attributes.website}`" >{{ attributes.website }}</a>
    </BaseLabelledInfo>
    <BaseLabelledInfo
      label="SPV"
      class="base-border-b pb-m"
    >
      {{ spvAttributes.name }}
    </BaseLabelledInfo>
    <BaseLabelledInfo

      :label="$t('Date of the first investment in the SPV')"
    >
      {{ date | moment('DD/MM/YYYY') }}
    </BaseLabelledInfo>
  </div>
</template>

<script>
import BaseSectionHeader from '../../components/BaseSectionHeader.vue';
import BaseLabelledInfo from '../../components/BaseLabelledInfo.vue';

export default {
  name: 'CompanyDetails',
  components: {
    BaseSectionHeader,
    BaseLabelledInfo,
  },
  props: {
    attributes: {
      type: Object,
      required: true,
    },
    spvAttributes: {
      type: Object,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="css" scoped>
</style>
